var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { ref: "layout", attrs: { view: "lHr LpR fFf" } },
    [
      _c(
        "q-layout-header",
        [
          _vm.activeTeam
            ? _c("subscription-status", { attrs: { team: _vm.activeTeam } })
            : _vm._e(),
          _c(
            "q-toolbar",
            {
              staticClass: "justify-between",
              attrs: { color: "white", "text-color": "grey-9" }
            },
            [
              !_vm.hasValidTeam
                ? _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "new-team" } } },
                        [
                          _c("div", { staticClass: "left-drawer-logo" }, [
                            _c("img", {
                              attrs: { src: require("assets/logo.svg") }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col row items-center" },
                [
                  _vm.hasValidTeam
                    ? _c("q-btn", {
                        staticClass: "col-auto lt-lg on-left",
                        attrs: { flat: "", round: "", dense: "", icon: "menu" },
                        on: {
                          click: function($event) {
                            _vm.showLeft = !_vm.showLeft
                          }
                        }
                      })
                    : _vm._e(),
                  _c("search-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasValidTeam,
                        expression: "hasValidTeam"
                      }
                    ],
                    staticClass: "col"
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-auto q-mr-lg" },
                [_c("quick-create")],
                1
              ),
              _c(
                "div",
                { staticClass: "col-auto row items-center justify-end" },
                [_c("user-section")],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.hasValidTeam
        ? _c(
            "q-layout-drawer",
            {
              attrs: { side: "left", width: 250 },
              model: {
                value: _vm.showLeft,
                callback: function($$v) {
                  _vm.showLeft = $$v
                },
                expression: "showLeft"
              }
            },
            [
              _c(
                "div",
                { staticClass: "column no-wrap full-height" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "dashboard",
                          params: { teamId: _vm.teamId }
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "left-drawer-logo" }, [
                        _c("img", {
                          attrs: { src: require("assets/logo.svg") }
                        })
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "column col-grow no-wrap justify-between" },
                    [
                      _c(
                        "q-list",
                        { attrs: { "no-border": "", link: "" } },
                        [
                          _c("q-list-header", [_vm._v(_vm._s(_vm.$t("menu")))]),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "dashboard",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", { attrs: { icon: "home" } }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$t("dashboard") }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "invoices",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", { attrs: { icon: "receipt" } }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$tc("invoice", 2) }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "quotes",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: { icon: "local_offer" }
                              }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$tc("quote", 2) }
                              })
                            ],
                            1
                          ),
                          _c(
                            "collapsible-item",
                            {
                              attrs: {
                                active:
                                  this.$route.meta && this.$route.meta.expenses
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "main" },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      attrs: {
                                        item: "",
                                        to: {
                                          name: "expenses-dashboard",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: { icon: "description" }
                                      }),
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$tc("expense", 2) }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "template",
                                { slot: "expanded" },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      attrs: {
                                        item: "",
                                        exact: "",
                                        to: {
                                          name: "expenses-dashboard",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t("overview") }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item",
                                    {
                                      attrs: {
                                        item: "",
                                        exact: "",
                                        to: {
                                          name: "expenses-list",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: _vm.$t("captured_expenses")
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item",
                                    {
                                      attrs: {
                                        item: "",
                                        exact: "",
                                        to: {
                                          name: "capture-expenses",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: _vm.$t(
                                            "capture_expenses_heading"
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "template",
                                { slot: "popover" },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      directives: [
                                        {
                                          name: "close-overlay",
                                          rawName: "v-close-overlay"
                                        }
                                      ],
                                      attrs: {
                                        item: "",
                                        exact: "",
                                        to: {
                                          name: "expenses-dashboard",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: { label: _vm.$t("overview") }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item",
                                    {
                                      directives: [
                                        {
                                          name: "close-overlay",
                                          rawName: "v-close-overlay"
                                        }
                                      ],
                                      attrs: {
                                        item: "",
                                        exact: "",
                                        to: {
                                          name: "expenses-list",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: _vm.$t("captured_expenses")
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item",
                                    {
                                      directives: [
                                        {
                                          name: "close-overlay",
                                          rawName: "v-close-overlay"
                                        }
                                      ],
                                      attrs: {
                                        item: "",
                                        exact: "",
                                        to: {
                                          name: "capture-expenses",
                                          params: { teamId: _vm.teamId }
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-main", {
                                        attrs: {
                                          label: _vm.$t(
                                            "capture_expenses_heading"
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "customers",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: { icon: "contacts" }
                              }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$tc("business_partner", 2) }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "items",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", {
                                attrs: { icon: "local_mall" }
                              }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$tc("item", 2) }
                              })
                            ],
                            1
                          ),
                          _c("time-entries-navigation-item"),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "projects",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", { attrs: { icon: "folder" } }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$tc("project", 2) }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            {
                              attrs: {
                                item: "",
                                to: {
                                  name: "finances",
                                  params: { teamId: _vm.teamId }
                                }
                              }
                            },
                            [
                              _c("q-item-side", { attrs: { icon: "euro" } }),
                              _c("q-item-main", {
                                attrs: { label: _vm.$tc("finance", 2) }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "q-pa-lg" },
                        [
                          _c("support-btn"),
                          _c("div", { staticClass: "row" }, [
                            _c("small", { staticClass: "q-mr-lg" }, [
                              _c("div", { staticClass: "q-pt-md" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "legal-link",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.imprintLink
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("imprint")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _c("small", [
                              _c("div", { staticClass: "q-pt-md" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "legal-link",
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.privacyPolicyLink
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("privacy_policy")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("q-page-container", [_c("router-view")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }